.errorDetails {
    border-radius: var(--mantine-radius-md);
}
